import { Box, styled } from "@mui/material";

const SidebarCardRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "width",
})(({ theme, width }) => ({
  width: width ?? "340px",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "16px",
  margin: "0.5rem 0.25rem 0.5rem 0.5rem",
  backgroundColor: "#fff",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  padding: "8px 6px",
  overflow: "hidden",
  boxSizing: "border-box",
}));

const SidebarCard = ({ children, width, className, sx, ...rest }) => (
  <SidebarCardRoot width={width} className={className} sx={sx} {...rest}>
    {children}
  </SidebarCardRoot>
);

export default SidebarCard;
